module.exports = __webpack_public_path__ + "img/builder.b43eaaa7.svg";